import { analiticaInstance } from '@payments-checkout/shared/plugins/analitica/analitica.events';
import { resolveScreenFromPathname } from '@payments-checkout/shared/plugins/analitica/analitica.helpers';
import { Modal, Text } from '@stone-payments/jade';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

export function ExpirationModal() {
  const { formatMessage } = useIntl();
  const screen = resolveScreenFromPathname(usePathname());

  useEffect(() => {
    analiticaInstance.events.expirationModal.sessionExpiredViewed(screen);
  }, []);

  return (
    <Modal
      actions={[
        {
          text: formatMessage({ id: 'expirationModal.button' }),
          variant: 'primary-solid',
          onClick: () => {
            analiticaInstance.events.expirationModal.refreshPageClicked(screen);
            window.location.reload();
          },
        }
      ]}
      open
      hideCloseButton
      title={formatMessage({ id: 'expirationModal.title' })}
      toggle={() => null}
    >
      <Text color="medium">
      {formatMessage({ id: 'expirationModal.message' })}
      </Text>
    </Modal>
  );
}
